module.exports = __webpack_public_path__ + "assets/images/chroma-animation_a6d45149ac995ed1f465f300f22aa76b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-one/chroma-animation.gif
// module id = 209
// module chunks = 0